import React, { useEffect } from "react";
import {
  Box,
  FormLabel,
  Heading,
  VStack,
} from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import Select from "react-select";
import MainInput from "../../../../components/Form/input";
import MainModel from "../../../../components/Models/main-model";
import { closeEditStudentPaymentModel } from "../../../../modules/admin-modules/models/Actions";
import { editStudentPaymentRequest } from "../../../../modules/admin-modules/payment/Actions";
import { getPaymentSubjectRequest } from "../../../../modules/admin-modules/videos/Actions";
import { getAllLecturesRequest } from "../../../../modules/admin-modules/lectures/Actions";

const EditStudentPayment = ({ data, setSelectedData }) => {
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.payments.isLoading);
  const paymentSubjects = useSelector((state) => state.videos.paymentSubjects);
  const lectures = useSelector((state) => state.lectures.lectures);
  const openEditModal = useSelector((state) => state.model.isOpen38);

  useEffect(() => {
    if (openEditModal) {
      dispatch(getPaymentSubjectRequest());
      dispatch(getAllLecturesRequest());
    }
  }, [openEditModal]);

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: data ? {
      paid_amount: data?.paid_amount,
      remaining_amount: data?.remaining_amount,
      payment_subject_id: data?.payment_subject_id,
      lecture_id: data?.lecture_id,
    } : {},
    shouldUnregister: true,
  });


  const header = (
    <Box>
      <Heading textAlign="center" color="main_1" fontSize="24px">
        تعديل دفع الطالب
      </Heading>
    </Box>
  );

  const onSubmit = (formData) => {
    const action = () => {
      dispatch(closeEditStudentPaymentModel());
      setSelectedData({});
      reset();
    };

    dispatch(
      editStudentPaymentRequest(
        data?.id,
        {
          paid_amount: formData.paid_amount,
          remaining_amount: formData.remaining_amount,
          payment_subject_id: formData.payment_subject_id,
          lecture_id: formData.lecture_id,
        },
        action
      )
    );
  };

  const closeFunc = () => {
    dispatch(closeEditStudentPaymentModel());
    setSelectedData({});
    reset();
  };

  const paymentSubjectsOptions = paymentSubjects?.map((subject) => ({
    value: subject.id,
    label: subject.name,
  }));

  const lecturesOptions = lectures?.map((lecture) => ({
    value: lecture.id,
    label: lecture.title,
  }));

  return (
    <MainModel
      isLoading={isLoading}
      header={header}
      closeFunc={closeFunc}
      openVar={openEditModal}
      buttonTitle="حفظ التعديلات"
      buttonFunc={handleSubmit(onSubmit)}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <VStack dir="rtl" w="100%" alignItems="flex-start" spacing={4}>
          <Box w="100%">
            <MainInput
              label="المبلغ المدفوع"
              error={errors?.paid_amount?.message}
              register={register}
              name="paid_amount"
              type="number"
              placeholder="ادخل المبلغ المدفوع"
              defaultValues={data?.paid_amount}
            />
          </Box>

          <Box w="100%">
            <MainInput
              label="المبلغ المتبقي"
              error={errors?.remaining_amount?.message}
              register={register}
              name="remaining_amount"
              type="number"
              placeholder="ادخل المبلغ المتبقي"
              defaultValues={data?.remaining_amount}
            />
          </Box>

          <Box w="100%">
            <FormLabel>الدفع</FormLabel>
            <Select
              options={paymentSubjectsOptions}
              defaultValue={paymentSubjectsOptions?.find(
                (option) => option.value === data?.payment_subject_id
              )}
              onChange={(selected) => setValue("payment_subject_id", selected.value)}
              placeholder="اختر الدفع"
              defaultInputValue={paymentSubjectsOptions?.find(
                (option) => option.value === data?.payment_subject_id
              )?.label}
            />
          </Box>

          <Box w="100%">
            <FormLabel>المحاضرة</FormLabel>
            <Select
              options={lecturesOptions}
              defaultValue={lecturesOptions?.find(
                (option) => option.value === data?.lecture_id
              )}
              onChange={(selected) => setValue("lecture_id", selected.value)}
              placeholder="اختر المحاضرة"
              defaultInputValue={lecturesOptions?.find(
                (option) => option.value === data?.lecture_id
              )?.label}
            />
          </Box>
        </VStack>
      </form>
    </MainModel>
  );
};

export default EditStudentPayment; 